module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/operator.6dad6524.svg";